"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type ReactNode } from "react";
import { Copy, Mail } from "lucide-react";
import { WhatsappShareButton, FacebookShareButton, FacebookMessengerShareButton } from "react-share";
import { useTranslations } from "next-intl";
import { MobileMenuItem } from "@/components/atoms/MobileMenuItem";
type Props = {
  url: string;
  title: string;
  heading?: string;
  children?: ReactNode;
};
export function ShareTargets(t0) {
  const $ = _c(45);
  const {
    url,
    title,
    heading,
    children
  } = t0;
  const t = useTranslations("common.share");
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== url) {
    t1 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t2) {
        const err = t2;
        console.error("Failed to copy: ", err);
      }
    };
    $[0] = url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopyLink = t1;
  let t2;
  if ($[2] !== heading || $[3] !== t) {
    t2 = heading ?? t("title");
    $[2] = heading;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <h2 className="font-normal text-foreground-heading text-2xl text-center px-8 sm:pt-0">{t2}</h2>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center"><div className="bg-[#25D366] rounded-full w-8 h-8 flex items-center justify-center"><svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="ShareTargets.tsx"><path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.88 11.94L4 20l4.2-1.1a7.93 7.93 0 0 0 3.8.96h.01a7.95 7.95 0 0 0 7.94-7.93 7.88 7.88 0 0 0-2.35-5.61zm-5.55 12.2h-.01a6.6 6.6 0 0 1-3.36-.92l-.24-.14-2.5.65.67-2.43-.16-.25a6.6 6.6 0 0 1-1.01-3.49 6.59 6.59 0 0 1 6.6-6.59c1.76 0 3.42.69 4.66 1.93a6.57 6.57 0 0 1 1.94 4.66 6.59 6.59 0 0 1-6.59 6.58zm3.61-4.94c-.2-.1-1.17-.58-1.35-.64-.18-.07-.32-.1-.45.1-.13.2-.5.64-.62.77-.11.13-.23.15-.43.05a5.44 5.44 0 0 1-2.7-2.35c-.2-.35.2-.33.58-1.1.07-.13.03-.24-.02-.34-.05-.1-.45-1.08-.62-1.47-.16-.39-.32-.33-.45-.34h-.38c-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66s.72 1.93.82 2.06c.1.13 1.4 2.14 3.4 3 .47.2.84.33 1.13.42.48.15.91.13 1.25.08.38-.06 1.17-.48 1.33-.94.17-.46.17-.86.12-.94-.05-.08-.18-.13-.38-.23z" data-sentry-element="path" data-sentry-source-file="ShareTargets.tsx" /></svg></div><span className="text-xs mt-1">WhatsApp</span></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== title || $[9] !== url) {
    t5 = <WhatsappShareButton url={url} title={title} separator=" - " className="flex justify-center" data-sentry-element="WhatsappShareButton" data-sentry-source-file="ShareTargets.tsx">{t4}</WhatsappShareButton>;
    $[8] = title;
    $[9] = url;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-col items-center"><div className="bg-[#1877F2] rounded-full w-8 h-8 flex items-center justify-center"><svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="ShareTargets.tsx"><path d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z" data-sentry-element="path" data-sentry-source-file="ShareTargets.tsx" /></svg></div><span className="text-xs mt-1">Facebook</span></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== url) {
    t7 = <FacebookShareButton url={url} hashtag="CasaStep" className="flex justify-center" data-sentry-element="FacebookShareButton" data-sentry-source-file="ShareTargets.tsx">{t6}</FacebookShareButton>;
    $[12] = url;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col items-center"><div className="bg-[#00B2FF] rounded-full w-8 h-8 flex items-center justify-center"><svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="ShareTargets.tsx"><path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17.16.14.26.39.27.65l.05 2.02c.02.65.69 1.07 1.27.75l2.26-1.24c.16-.09.34-.14.52-.14.18 0 .36.05.52.13 1.22.44 2.53.67 3.91.67 5.64 0 10-4.13 10-9.7C22 6.13 17.64 2 12 2zm6 7.46-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.37l2.34 1.73a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63z" data-sentry-element="path" data-sentry-source-file="ShareTargets.tsx" /></svg></div><span className="text-xs mt-1">Messenger</span></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== url) {
    t9 = <FacebookMessengerShareButton url={url} appId="123456789" className="flex justify-center" data-sentry-element="FacebookMessengerShareButton" data-sentry-source-file="ShareTargets.tsx">{t8}</FacebookMessengerShareButton>;
    $[15] = url;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="bg-white border border-border rounded-full w-8 h-8 flex items-center justify-center"><Mail className="w-4 h-4 text-foreground" data-sentry-element="Mail" data-sentry-source-file="ShareTargets.tsx" /></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t) {
    t12 = t("email");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <span className="text-xs mt-1">{t12}</span>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t13) {
    t14 = <a href={t10} className="flex flex-col items-center">{t11}{t13}</a>;
    $[22] = t10;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t5 || $[27] !== t7 || $[28] !== t9) {
    t15 = <div className="grid grid-cols-4 gap-2 mb-4 pt-4">{t5}{t7}{t9}{t14}</div>;
    $[25] = t14;
    $[26] = t5;
    $[27] = t7;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="border-t border-border pt-4" />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Copy />;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== copied || $[33] !== t) {
    t18 = copied ? t("linkCopied") : t("copyLink");
    $[32] = copied;
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== handleCopyLink || $[36] !== t18) {
    t19 = <MobileMenuItem icon={t17} title={t18} onClick={handleCopyLink} data-sentry-element="MobileMenuItem" data-sentry-source-file="ShareTargets.tsx" />;
    $[35] = handleCopyLink;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== children || $[39] !== t19) {
    t20 = <div className="flex flex-col gap-2">{t19}{children}</div>;
    $[38] = children;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t15 || $[42] !== t20 || $[43] !== t3) {
    t21 = <>{t3}{t15}{t16}{t20}</>;
    $[41] = t15;
    $[42] = t20;
    $[43] = t3;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
}